import React from 'react';
import { useCloudampDataRef } from '../../../hooks/useCloudampData';

/**
 * SelfScheduleConsultStub (WEBDEV-4187)
 *
 * Rendered in place of the Consult form when the self-schedule variant is
 * active but the on-page form is not (variant '1', or variant '2' with the
 * ON_PAGE_FORM_ENABLED kill-switch off).
 *
 * Keeps a hidden cloudamp target on the page so the cloudamp library still has
 * a field to populate once the real form is gone. It reuses useCloudampDataRef
 * — the same hook the real consult forms use — so the populate/poll/persist-to-
 * localStorage cycle still runs and every other form on the site (quote,
 * contact, FAQs, newsletter) keeps getting attribution data. Without this, the
 * variant arm would quietly lose cloudamp attribution site-wide, since
 * theme-2023's other forms have no cloudamp input of their own and read the
 * localStorage value this cycle writes.
 *
 * Render exactly one stub per page so only one cloudamp field drives the cycle.
 */
export function SelfScheduleConsultStub() {
    const cloudampDataRef = useCloudampDataRef();
    return (
        <form style={{ display: 'none' }}>
            <input ref={cloudampDataRef} type="hidden" name="cloudamp__data__c" />
        </form>
    );
}

export default SelfScheduleConsultStub;
